import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { AccuracyType } from 'api/query/shared/accuracy-type.enum';
import { LinkageTag } from 'components/Linkage-tag/linkage-tag';
import PercentileTag, { PercentileHighlight } from 'components/percentile-tag';
import { useUser } from 'providers/user/use-user';
import React from 'react';
import { MiniTableProps } from './mini-table-props';
import './mini-table.scss';

/**
 * Mini version of table to display traits.
 */
export const MiniTable: React.FC<MiniTableProps> = (props) => {
  const {
    percentileHighlights = {
      top: PercentileHighlight.Top20,
      bottom: PercentileHighlight.BottomNone,
    },
  } = props;

  const { isAdmin } = useUser();

  return (
    <Table className="sg-mini-table">
      <TableHead>
        <TableRow>
          {props.headerLabels.map((label) => (
            <TableCell key={label}>{label}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {props.traits.map((asbv) => (
          <TableRow key={asbv.name}>
            {props.showTraitColumn && <TableCell>{asbv.name}</TableCell>}
            <TableCell className={isAdmin && asbv.accuracyType !== AccuracyType.Linked && asbv.accuracy !== '' ? 'sg-mini-table--red' : ''}>{asbv.value}</TableCell>
            <TableCell className={isAdmin && asbv.accuracyType !== AccuracyType.Linked && asbv.accuracy !== '' ? 'sg-mini-table--red' : ''}>{asbv.accuracy}</TableCell>
            <TableCell className="sg-mini-table__tag">
              <PercentileTag
                percentile={asbv.percentile}
                checkVisiblity
                hasLeader={asbv.hasLeader}
                isRbv={asbv.isRbv}
                selectedTop={percentileHighlights.top}
                selectedBottom={percentileHighlights.bottom}
                isRange
              />
              <LinkageTag
                accuracyType={asbv.accuracyType}
                accuracy={asbv.accuracy}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

// (MiniTable as any).whyDidYouRender = {
//   customName: 'MiniTable',
// };
